export const showAsTentative = "VyJoTe";
export default {showAsTentative};